module.exports = __webpack_public_path__ + "static/media/premium.db10d13e.png";